import { Content, ContentHeader, InputSearch, Paging, QueryState, QueryStateContent, Stack, Table, TableBody, TableCell, TableHead, TableRow } from 'src/app/components';
import { useEffect } from 'react';
import { SalesPromoParticipant, SalesPromoPrizeModel } from 'src/app/modules/campaign/models/SalesPromo.model';
import { useSalesPromoTabDetailParticipantDetail } from './SalesPromoTabParticipantDetail.hook';
import dayjs from 'dayjs';

interface SalesPromoTabParticipantPrizeListProps {
    id?: string
    data?: SalesPromoParticipant
}

export function SalesPromoTabParticipantPointHistory(props: Readonly<SalesPromoTabParticipantPrizeListProps>) {

    const state = useSalesPromoTabDetailParticipantDetail();
    const prizes = state.participantPrizeList;
    useEffect(() => {
    }, [])

    const renderItem = (item: SalesPromoPrizeModel, index: number) => {
        return (
            <TableRow key={item.id}>
                <TableCell {...{ index }} />
                <TableCell value={item?.receipt_codes} renderValue={(val: string[]) => {
                    return <ul>
                        {val.map((item: string, index: number) => (<li key={item + index}>{item}</li>))}
                    </ul>
                }} />
                <TableCell value={item?.quantity} />
                <TableCell
                    renderValue={(date: string) => {
                        return (
                            <div>
                                {dayjs(date).format('DD/MM/YYYY HH:mm:ss')}
                            </div>
                        )
                    }}
                    className="w-[145px]"
                    value={item?.claimed_at}
                />            </TableRow>
        )
    }


    return (
        <>
            <Stack className='py-6'>
                <Content>
                    <ContentHeader title="Point History" />
                    <Stack
                        direction="row"
                        justify="between"
                        items="center"
                        className="px-6 py-4"
                    >
                        <InputSearch />
                    </Stack>
                    <QueryState query={prizes}>
                        <div className="px-8">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell index />
                                        <TableCell>Receipt ID</TableCell>
                                        <TableCell>Point Earned</TableCell>
                                        <TableCell>Claimed Date</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {prizes.data?.content?.map(renderItem)}
                                </TableBody>
                            </Table>
                            <Paging query={prizes} />
                        </div>
                        <QueryStateContent title="List Point History is Empty" description=" " />
                    </QueryState>
                </Content>
            </Stack>
        </>
    )
}
